module.exports = __webpack_public_path__ + "img/IT0000511477421.7ea7dc5f.png";